<div class="wrapperStyle  ">
  <div id="main-wrapper">
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
    <app-header (found)="handleResults($event)"></app-header>
    <div class=" tab inner-tab-container dashboardContainer main-background topSpace main-container">
      <app-search-results [resultGridList]="data"></app-search-results>
      <!-- Nav tabs -->
      <ul class="nav nav-tabs cup-detail-header" role="tablist">
        <li role="presentation" class="active">
          <div class="pcpLabels"> PCP Score Card </div>
          <a href="#Section1" aria-controls="home" role="tab" data-toggle="tab" style="min-width: 16em"></a>
        </li>
      </ul>

      <div class="dashboard-content">
        <div class="tab-pane dashboard-pane">
          <div class="row">
            <div
              class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
              <label for="memberHealthPlan"><span class="required">*</span> SITE</label>
              <cup-autocomplete class="form-control input-underline" [colWidth]="16" [(ngModel)]="selectedSite"
                [autoCompleteModel]="selectedSite" [autoCompleteDynamic]="true" [autoCompleteOptions]="sites"
                (autoCompleteModelChange)="setProviders($event)" emptyMessage='No Sites Found'
              [autoCompletePlaceholder]="'Select Site'"></cup-autocomplete>
            </div>

            <div
              class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
              style="position: relative;">
              <div>
                <label for="provider"><span class="required">*</span> PRIMARY CARE PHYSICIANS</label>
                <cup-autocomplete [isDisabled]="pcpDropdownforDCE" class="form-control input-underline" [colWidth]="16"
                  [autoCompleteModel]="selectedProviderModel" emptyMessage='No Providers Found'
                  [autoCompleteDynamic]="true" [autoCompleteOptions]="providers"
                  (autoCompleteModelChange)="onProvidersSubmit($event)"
                  [autoCompletePlaceholder]="'Select PRIMARY CARE PHYSICIANS'">
                </cup-autocomplete>
              </div>
            </div>



            <div class="col-md-12">
              @if (providerAffiliationList) {
                <div class="col-md-12 providerAff">
                  <div class="form-group provider-affiliated-list-view">
                    <label> Provider Affiliation </label>
                    <div class="inner-list-view">
                      <ul class="p-0">
                        @for (provider of providerAffiliationList; track provider) {
                          <li>
                            <span href="javascript:void(0)">{{ provider.name }}</span>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                  @if (showNoRecords) {
                    <div class="form-group col-md-4 col-xs-12 alert">
                      No PCP Score card details found.
                    </div>
                  }
                  <button class="btn green reportBtn" style="float: right;" (click)="generatePCPScoreCard()" [disabled]="showNoRecords">Generate PCP Score Card</button>
                  <br>
                    @if (pcpscorecard) {
                      <div class="container-fluid row" style="margin: 40px;">
                        <div class="col-md-11">
                          <h2 style="text-align: center">PCP PERFORMANCE TRACKING</h2>
                          <br/>
                          <div>
                            <div class="pull-left text-left">
                              <div class="SmallTitle">{{pcpdetails[0].pcpname}}</div>
                              <div class="SmallTitle">{{pcpdetails[0].pcpaddress}}</div>
                            </div>
                            <div class="pull-right text-right">
                              <div class="SmallTitle">Region: {{ pcpdetails[0].pcpregion}}</div>
                              <div class="SmallTitle">Neighborhood: {{ omprFinalData[0] ?omprFinalData[0].neighborhood : " "}}</div>
                            </div>
                            <br>
                              <br>
                              </div>
                              <br>
                                <br>
                                  <table id=”my-table” class="table table-bordered">
                                    <thead class="heading-pcp">
                                      <tr>
                                        <th >Category</th>
                                        <th >PCP</th>
                                        <!-- <th >Neighborhood</th>
                                        <th >Region</th> -->
                                        <th>Benchmark</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td colspan="3">Data: Between {{omprFinalData[0] ? omprFinalData[0].opmrbdt: '' }}-{{omprFinalData[0] ? omprFinalData[0].opmredt: '' }}</td>
                                      </tr>
                                      <!-- <tr>
                                      <td>MLR</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].mlr: '' }}</td>
                                      <td></td>
                                    </tr> -->
                                    <tr>
                                      <td>Pharmacy Total Scripts PMPM</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].pharmacyTotalScriptsPMPM: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>Rx Generic Utilization %</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].pharmacyGenericUtilization: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>ER Visits PTMPY</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].erVisitsPTMPY: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>Urgent Care Visits PTMPY</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].urgentCareVisitsPTMPY: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>CCC Visits PTMPY</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].cccVisitsPTMPY: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>Encounter Data PMPY</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].careMoreEncountersPMPY: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="3">Overall STAR Rating [Part C (HEDIS/HOS) + Part D]: As of  {{latestdate}}</td>
                                    </tr>
                                    <tr>
                                      <td>Overall Star Rating</td>
                                      <td>{{omprFinalData[0] ? omprFinalData[0].overallStarRating: '' }}</td>
                                      <!-- <td></td>
                                      <td></td> -->
                                      <td></td>
                                    </tr>
                                    <!-- <tr>
                                    <td colspan="5">Part D Measures: Between {{latestdate}} - {{latestdate}}</td>
                                  </tr>
                                  <tr>
                                    <td>Medication Adherence - Diabetes (OralDb)</td>
                                    <td>{{diseasesList53[0] ? diseasesList53[0].ratecomplete+'%' : '' }}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{diseasesList53[0] ? diseasesList53[0].targetGoal : ''}}</td>
                                  </tr>
                                  <tr>
                                    <td>Medication Adherence - Hypertension (RAS Antagonists))</td>
                                    <td>{{diseasesList51[0] ? diseasesList51[0].ratecomplete+'%': ''}}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{diseasesList51[0] ? diseasesList51[0].targetGoal:''}}</td>
                                  </tr>
                                  <tr>
                                    <td>Medication Adherence - Cholesterol (Statins)</td>
                                    <td>{{diseasesList52[0] ? diseasesList52[0].ratecomplete+'%' : ''}}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{diseasesList52[0] ? diseasesList52[0].targetGoal : ''}}</td>
                                  </tr>
                                  <tr>
                                    <td>Statin Use in Persons with Diabetes</td>
                                    <td>{{diseasesList58[0] ?diseasesList58[0].ratecomplete+'%' : ''}}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{diseasesList58[0] ?diseasesList58[0].targetGoal : ''}}</td>
                                  </tr>
                                  <tr>
                                    <td>Statin Use in Persons with Cardiovascular Disease</td>
                                    <td>{{diseasesList57[0] ?diseasesList57[0].ratecomplete+'%' :''}}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{diseasesList57[0] ? diseasesList57[0].targetGoal : ''}}</td>
                                  </tr> -->
                                  <tr>
                                    <td colspan="3">Membership: As of  {{latestdate}}</td>
                                  </tr>
                                  <tr>
                                    <td>Membership</td>
                                    <td>{{memlength.length}}</td>
                                    <!-- <td></td>
                                    <td></td> -->
                                    <td>NA</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div>
                            <button class="pcpsubmitbutton" (click)="createPdf()">Create PDF</button>
                          </div>
                        }
                      </div>
                    }

                    <!-- <div class="form-group col-md-4 col-xs-12 alert" *ngIf="showNoRecords">
                    No PCP Score card details found.
                  </div> -->

                </div>



              </div>
            </div>
          </div>
        </div>
      </div>


      <app-footer></app-footer>
    </div>